import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import comingSoonImg from './coming-soon.png';

function App() {
  return (
    <div className="d-flex vh-100 align-items-center justify-content-center bg-light">
      <div className="text-center">
        <img src={comingSoonImg} alt="Coming Soon" className="img-fluid mb-4" style={{ maxWidth: '500px' }} />
        <h2 className="text-muted">Estamos trabajando en algo genial. ¡Vuelve pronto!</h2>
      </div>
    </div>
  );
}

export default App;
